import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import DeviceContext from "../../../utils/indentifyDevice";
import PnLTable from "./Desktop/PnLTable";
import PnLTableMob from "./Mobile/PnLTableMob";
import CalendarPopupDesk from "../../generic/Calendar/CalendarPopupDesk";
import CalendarPopupMob from "../../generic/Calendar/CalendarPopupMob";
import PnLDownloadSortFilter from "./Desktop/PnLDownloadSortFilter";
import PnLDownloadSortFilterMob from "./Mobile/PnLDownloadSortFilterMob";
import PnlStockDetails from "./PnlStockDetails/PnlStockDetails";
import Drawer from "react-bottom-drawer";
import { useDispatch } from "react-redux";
import moment from "moment";
import di from "../PNLReports/di/servicelocator";
import { useSelector } from "react-redux";
import PopupLoader from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import SuccessPopup from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import PopupFail from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import FilterLabels from "../../../components/generic/FilterLabels/FilterLabels";
import { PNL_HIDE_ERROR, } from "../../../redux/interfaces/Reports/iPNLReport";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PNLErrorEnum } from "@adapters/presenters/action-interfaces/Reports/PNLReport";
import SortLabels from "@frameworks/web/components/generic/SortLabels/SortLabel";
import CommonSummary from "../CommonComponent/CommonSummary";
import { ESortOrder } from "@domains/utils/sort";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { StockDetailsEnum } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import { getFinancialYear, getFinancialYears, EDurationType, previousDay, tillDateStartDate, } from "@domains/utils/reportDates";
import { TransactionType, } from "@domains/aggregates/interfaces/Reports/iPNLTransactionReport";
import EditTransactionPopup from "./PnlEditScreen/EditTransactionPopup";
import ConfirmationPopup from "@frameworks/web/components/generic/ConfirmationPopup/ConfirmationPopup";
import SmcasePopupSuccess from "@frameworks/web/components/Reports/HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import SmcasePopupFail from "@frameworks/web/components/Reports/HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import DownloadReportPopupDesk, { DownloadEnumReportType, } from "@frameworks/web/components/generic/DownloadReports/DownloadReportPopupDesk";
import { getDay } from "@domains/utils/reportDates";
import EdModal from "@frameworks/web/components/generic/edModal";
import PNLFilterLabelDynamic from "./PNLFilterLabelDynamic";
import "@frameworks/web/stylesheets/components/dowloadHoldingReports/dowloadHoldingReports.scss";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import FamilyTaggingMain from "../FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import { EConsolidated } from "../constant";
import CommonSummaryMobile from "../CommonComponent/CommonSummaryMobile";
import PopBodProcessBlock from "../RebrandedReports/GenericComponents/PopBodProcessBlock";
import { getPNLSubHeadingName } from "./constant";
const ProfitAndLossComponent = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const navigate = useNavigate();
    const device = DeviceContext();
    const location = useLocation();
    const { loginOrigin } = useParams();
    const [refresh, setRefresh] = React.useState(location.state && location.state.refresh ? location.state.refresh : false);
    const { selectedMember } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const selectedStockDetailsFromStore = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnlReport.selectedStockDetails);
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const [openCalendar, setOpenCalendar] = React.useState(false);
    const wrapperRef = React.useRef(null);
    const calendarRef = React.useRef(null);
    const filterSortScrollRef = React.useRef(null);
    let scroll = JSON.parse(sessionStorage.getItem("filterSortScrollRefPNL"));
    const [sortOptionSelected, setSortoptionSelected] = React.useState(false);
    const prodDropDown = useSelector((state) => state.pnlReport.prodDropDown);
    const initSelectOption = () => {
        if (prodDropDown)
            return prodDropDown;
        if (props.selectedAssetType) {
            let found = props.assetFilter.assetProductList.find((x) => x.value.toString().toLowerCase() ==
                props.selectedAssetType.toLowerCase());
            if (found)
                return {
                    display: found.display,
                    value: found.value,
                };
            return props.assetFilter.assetProductList[0];
        }
        return props.assetFilter.assetProductList[0];
    };
    const [selectOption, setSelectedOption] = React.useState(initSelectOption());
    const [showOptions, setShowOptions] = React.useState(false);
    const [defaultTab, setDefaultTab] = React.useState(StockDetailsEnum.OVERVIEW);
    const [pnlStockDisplay, setPnlStockDisplay] = React.useState(false);
    const [pnlStockDetails, setPnlStockDetails] = React.useState((selectedStockDetailsFromStore === null || selectedStockDetailsFromStore === void 0 ? void 0 : selectedStockDetailsFromStore.tradeDetails)
        ? selectedStockDetailsFromStore.tradeDetails
        : null);
    const [showPnlStockDrawer, setShowPnlStockDrawer] = React.useState(false);
    const [showLoaderDownloadSideBar, setShowLoaderDownloadSideBar] = React.useState(false);
    const [downloadSuccessDownloadSideBar, setDownloadSuccessDownloadSideBar] = React.useState(false);
    const [downloadFailDownloadSideBar, setDownloadFailDownloadSideBar] = React.useState(false);
    const [searchVal, setSearchVal] = React.useState();
    const [showSortDropdown, setshowSortDropdown] = React.useState(false);
    const [downloadPopUp, setDownloadPopUp] = useState(false);
    const [downloadPopUpSideBar, setDownloadPopUpSideBar] = useState(false);
    const [showEditablePopup, setShowEditablePopup] = useState(false);
    const [reviewChangePopup, setReviewChangePopup] = useState(false);
    const [editableRecord, seteditableRecord] = useState(null);
    const [editPNLTransactionFail, setEditPNLTransactionFail] = useState(false);
    const [editPNLTransactionSuccess, setEditPNLTransactionSuccess] = useState(false);
    const [editPNLTransactionAPICall, seteditPNLTransactionAPICall] = useState(false);
    const [summaryParamters, setSummaryParameters] = React.useState();
    const [pnLEditSplitRequests, setPnLEditSplitRequests] = React.useState([]);
    const [dwnldtransactionType, setDwnldTransactionType] = useState();
    const financialYears = getFinancialYears(props.startDate, props.endDate, props.tillDateSelected);
    const { txnStatus: txnStatusError, editTXNShimmer: editTXNShimmer, pnlOriginalTxns: pnlOriginalTxns, orgTxnLoader: orgTxnLoader, orgTxnStatus: orgTxnStatus, } = useSelector((state) => state.pnltranasactionReport);
    const AccountDetails = useSelector((state) => state.accountDetailsReducer);
    const familyTaggingMemberName = useSelector((state) => { var _a, _b; return (_b = (_a = state.FamilyTagging.familyDetails.reducersData) === null || _a === void 0 ? void 0 : _a.selectedMember) === null || _b === void 0 ? void 0 : _b.memberName; });
    const [FilterDataApplied, setFilterDataApplied] = React.useState(false);
    const filters = useSelector((state) => { var _a, _b; return (_b = (_a = state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.FilterData; });
    const sort = useSelector((state) => { var _a, _b; return (_b = (_a = state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SortData; });
    const sortDisplayName = (_a = sort === null || sort === void 0 ? void 0 : sort.filter((val) => (val === null || val === void 0 ? void 0 : val.order) != 0)[0]) === null || _a === void 0 ? void 0 : _a.displayName;
    const { pnLSummary: pnlSummary, pnLDetails: pnLDetails, pnlDataFlags: PnlDataFlags, } = useSelector((state) => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.PnLData; });
    const showShimmer = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnlReport.showShimmer);
    const searchData = useSelector((state) => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SearchData; });
    const dispatch = useDispatch();
    const closeDrawer = () => {
        setShowPnlStockDrawer(false);
        setPnlStockDetails(null);
    };
    const showFDotCounter = () => {
        var _a, _b;
        if (filters) {
            let total = 0;
            for (let key in filters) {
                if (key == ((_b = (_a = di.pnlReport.filterState) === null || _a === void 0 ? void 0 : _a.productAssetFilter) === null || _b === void 0 ? void 0 : _b.name))
                    continue;
                if (filters[key] &&
                    filters[key].filters &&
                    filters[key].filters.length > 0)
                    total =
                        total +
                            filters[key].filters.filter((tags) => tags === null || tags === void 0 ? void 0 : tags.selected).length;
            }
            return total;
        }
    };
    const [showFDot, setShowFDot] = React.useState(0);
    const [showSearchParent, setShowSearchParent] = React.useState(false);
    const pnlSubTab = React.useMemo(() => {
        return getPNLSubHeadingName(props.tabName);
    }, [props.tabName]);
    const clearAllFilter = async () => {
        di === null || di === void 0 ? void 0 : di.pnlReport.getFilteredPNLReportData({
            simpleFilter: {
                name: "Filter By",
                filters: di.pnlReport.removeFilter(filters.simpleFilter.filters),
            },
            assetFilter: filters === null || filters === void 0 ? void 0 : filters.assetFilter,
            productAssetFilter: filters === null || filters === void 0 ? void 0 : filters.productAssetFilter,
        }, props.tabName);
        di.pnlReport.removeSessionFilters();
        setFilterDataApplied(false);
        setShowFDot(0);
    };
    const resetSort = () => {
        di.pnlReport.getSortedPNLReportData({
            displayName: "Alphabetical",
            order: ESortOrder.DESC,
            sortName: "displayName",
        }, false, props.tabName);
        //set red dot on sort function
        setSortoptionSelected(false);
        setshowSortDropdown(false);
    };
    const clearAllLabels = () => {
        // if (emptyValidation === EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL])
        //   return; BA to come back
        resetSort();
        clearAllFilter();
    };
    const handleScroll = () => {
        setScrollPosition(window.pageYOffset);
    };
    const closeOptions = (selected) => {
        var _a, _b;
        if ((_b = (_a = filters === null || filters === void 0 ? void 0 : filters.productAssetFilter) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.find((x) => x.title === selected.display)) {
            setShowOptions(false);
            return;
        }
        di.pnlReport.saveProdAssetDropDown(selected);
        setShowOptions(false);
        setSelectedOption(selected);
        selectOptionUpdateToBeFollowedBy(selected);
        assetFilterUpdate(selected, "productAssetFilter");
        di.pnlReport.viewTransactionClickScrollerPosition = 0;
        di.pnlReport.LThreeWindowbackClick = false;
        if (props.tabName === "others")
            GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.PNL, ReportsGTMConstants.NewReports, `${ReportsGTMConstants.Others} | ${selected.value}`));
    };
    const tillDate = () => {
        return [
            {
                displayText: "Till Date",
                Functionality: () => {
                    var _a, _b;
                    let durationType = EDurationType.NA;
                    setOpenCalendar(false);
                    (_a = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _a === void 0 ? void 0 : _a.call(props, tillDateStartDate);
                    (_b = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _b === void 0 ? void 0 : _b.call(props, previousDay);
                    props.setFinYear(getFinancialYear(tillDateStartDate));
                    props.setTillDateSelected(true);
                    di.pnlReport.removeSessionFilters();
                    di.pnlReport.viewTransactionClickScrollerPosition = 0;
                    di.pnlReport.LThreeWindowbackClick = false;
                    const payload = {
                        fromDate: moment(tillDateStartDate).format("yyyy-MM-DD"),
                        toDate: moment(previousDay).format("yyyy-MM-DD"),
                        assetType: selectOption.value,
                        duration: durationType,
                    };
                    if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)
                        payload.accountIds = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
                    di.pnlReport.getPNLReportData(payload);
                    if (props.handlePNLDates)
                        props.handlePNLDates(durationType, tillDateStartDate, previousDay);
                },
            },
        ];
    };
    const editTransaction = (txn) => {
        seteditableRecord(txn);
        setPNLSummaryParameters();
        setShowEditablePopup(true);
        setPnlStockDisplay(false);
        getOriginalTxns(txn);
    };
    const editConfirmation = () => {
        setShowEditablePopup(false);
        setReviewChangePopup(true);
    };
    const reviewGoBack = () => {
        setReviewChangePopup(false);
        setShowEditablePopup(true);
    };
    const setPNLSummaryParameters = () => {
        if (pnlStockDetails) {
            let txnType = (pnlStockDetails === null || pnlStockDetails === void 0 ? void 0 : pnlStockDetails.isRealisedPnL) && (pnlStockDetails === null || pnlStockDetails === void 0 ? void 0 : pnlStockDetails.isUnrealisedPnL)
                ? TransactionType.TRANSACTION
                : (pnlStockDetails === null || pnlStockDetails === void 0 ? void 0 : pnlStockDetails.isRealisedPnL)
                    ? TransactionType.REALISED
                    : TransactionType.UNREALISED;
            const summaryObj = {
                isin: pnlStockDetails.quote.isin,
                scripName: pnlStockDetails.scripName,
                companyName: pnlStockDetails.quote.description,
                qty: (pnlStockDetails === null || pnlStockDetails === void 0 ? void 0 : pnlStockDetails.isRealisedPnL)
                    ? pnlStockDetails.realisedQuantity
                    : pnlStockDetails.unrealisedBuyQuantity,
                ltp: pnlStockDetails.quote.lastTradedPrice,
                scripIdentifier: pnlStockDetails.scripIdentifier,
                fromDate: props.startDate,
                toDate: props.endDate,
                transactionType: txnType,
                assetType: selectOption.value,
                change: pnlStockDetails.quote.change,
                changePercentage: pnlStockDetails.quote.changePercentage,
            };
            setSummaryParameters(summaryObj);
        }
    };
    const sendSplitRecord = () => {
        if (summaryParamters) {
            let tempData = pnLEditSplitRequests;
            if (pnLEditSplitRequests && pnLEditSplitRequests.length > 0) {
                tempData = pnLEditSplitRequests.map((editRecord) => {
                    editRecord.newDate =
                        moment(editRecord.newDate).format("yyyy-MM-DD") == "Invalid date"
                            ? moment(editRecord.newDate, "DD-MM-YY").format("yyyy-MM-DD")
                            : moment(editRecord.newDate).format("yyyy-MM-DD");
                    return editRecord;
                });
            }
            const payload = {
                accountId: AccountDetails.accountCode,
                fromDate: moment(summaryParamters.fromDate).format("yyyy-MM-DD"),
                toDate: moment(summaryParamters.toDate).format("yyyy-MM-DD"),
                transactionType: summaryParamters.transactionType,
                scripIdentifier: editableRecord === null || editableRecord === void 0 ? void 0 : editableRecord.scripIdentifier,
                pnLEditSplitRequests: tempData,
                duration: props.durationType,
            };
            di.pnlTransactionReport.sendEditSplitPNLTransactionData(payload);
            seteditPNLTransactionAPICall(true);
        }
    };
    const reviewConfirm = () => {
        setReviewChangePopup(false);
        sendSplitRecord();
    };
    const getOriginalTxns = (editableRecord) => {
        let payload = {
            pnLEditSplitRequests: [{ transactionId: editableRecord.transactionId }],
        };
        di.pnlTransactionReport.getOriginalTxns(payload);
    };
    const goBackToPNLReport = () => {
        dispatch({
            type: PNL_HIDE_ERROR,
            errorType: PNLErrorEnum.DOWNLOADSTATUS,
        });
        // Build URL parameters
        const params = new URLSearchParams({
            reportName: "ProfitandLoss",
            tab: props.tabKey,
            assetType: selectOption.value,
            fromDate: moment(props.startDate).format("yyyy-MM-DD"),
            toDate: moment(props.endDate).format("yyyy-MM-DD"),
            durationType: props.durationType,
        });
        // Construct the destination URL
        const baseUrl = ".." + getLoginSourceURL(loginOrigin);
        const destination = `${baseUrl}?${params.toString()}`;
        // Navigate to the destination
        navigate(destination, { replace: true });
    };
    const assetFilterUpdate = (val, filterName) => {
        try {
            let newfilters = [];
            if (val.value) {
                if (val.display === "All") {
                    const payload = {
                        fromDate: moment(props.startDate).format("yyyy-MM-DD"),
                        toDate: moment(props.endDate).format("yyyy-MM-DD"),
                        assetType: selectOption.value,
                    };
                    if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)
                        payload.accountIds = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
                    di.pnlReport.getPNLReportData(payload);
                }
                else {
                    let newAssetFilter = [];
                    newfilters = ["productAssetFilter"].map((name) => {
                        let addNewAsset = [...filters[name].filters].findIndex((x) => x.key === val.value);
                        if (addNewAsset === -1 && name === filterName) {
                            newAssetFilter.push({
                                title: val.display,
                                key: val.value,
                                selected: true,
                            });
                        }
                        return {
                            [name]: Object.assign(Object.assign({}, filters[name]), { filters: newAssetFilter }),
                        };
                    });
                }
            }
        }
        catch (error) { }
        setSelectedOption((selected) => {
            const payload = {
                fromDate: moment(props.startDate).format("yyyy-MM-DD"),
                toDate: moment(props.endDate).format("yyyy-MM-DD"),
                assetType: selected.value,
            };
            if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)
                payload.accountIds = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
            di.pnlReport.getPNLReportData(payload);
            return selected;
        });
    };
    const selectOptionUpdateToBeFollowedBy = (select) => {
        props.setAssetTypeOnGoBack((prevState) => {
            if (prevState === select.value)
                return prevState;
            return select.value;
        });
    };
    const updateSideBarStockMemoised = useMemo(() => {
        if (pnlStockDisplay && pnlStockDetails) {
            let found = pnLDetails.findIndex((x) => x.scripIdentifier !== "" &&
                x.scripIdentifier.toString() ===
                    pnlStockDetails.scripIdentifier.toString());
            if (found)
                return found;
        }
    }, [pnlStockDisplay, pnlStockDetails]);
    const updateSideBarStock = (memoisedSelectedStock) => {
        if (pnLDetails && pnlStockDetails) {
            setPnlStockDetails(pnLDetails[memoisedSelectedStock]);
        }
    };
    const TablefilterSelected = () => {
        return (pnLDetails.length > 0 && ((searchVal === null || searchVal === void 0 ? void 0 : searchVal.length) > 0 || FilterDataApplied));
    };
    const commonSummaryValues = () => {
        let isDesktop = device === null || device === void 0 ? void 0 : device.isDesktop;
        let summary = [
            {
                title: "Total P&L",
                value: pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.totalPnl,
                integer: true,
                percentageValue: pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.totalPnlChangePercent,
                externalClassName: isDesktop ? "summary_box" : "dashboard_summary",
            },
            {
                title: "Realized P&L",
                value: pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.realisedPnl,
                integer: true,
                percentageValue: pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.realisedPnlChangePercent,
                externalClassName: isDesktop ? "summary_box" : "dashboard_summary",
            },
            {
                title: "Unrealized P&L",
                value: pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.unrealisedPnl,
                integer: true,
                percentageValue: pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.unrealisedPnlChangePercent,
                externalClassName: isDesktop ? "summary_box" : "dashboard_summary",
            },
        ];
        if (isDesktop)
            summary.push({
                title: "Day's P&L",
                value: pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.daysPnLChange,
                integer: true,
                externalClassName: "summary_box background_blue",
                percentageValue: undefined,
            });
        return summary;
    };
    const submitEmailDownload = (email, download) => {
        if (dwnldtransactionType && pnlStockDetails) {
            download.transactionType = dwnldtransactionType;
            download.scripIdentifier = pnlStockDetails.scripIdentifier;
            download.accountId = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
            download.duration = props.durationType;
            di.pnlReport.downloadTransactionReport(download);
        }
    };
    const removeSessionOnDateChange = () => {
        di.pnlReport.removeSessionFilters();
        props.setTillDateSelected(false);
        di.pnlReport.viewTransactionClickScrollerPosition = 0;
        di.pnlReport.LThreeWindowbackClick = false;
    };
    const handleInternalScroll = () => {
        if (filterSortScrollRef && filterSortScrollRef.current)
            sessionStorage.setItem("filterSortScrollRefPNL", JSON.stringify(filterSortScrollRef.current.scrollLeft));
    };
    const setInternalScroll = () => {
        if (filterSortScrollRef && filterSortScrollRef.current)
            filterSortScrollRef.current.scrollLeft = Number(scroll);
    };
    useEffect(() => {
        if (editPNLTransactionAPICall &&
            txnStatusError &&
            txnStatusError.isOpen !== null &&
            (device === null || device === void 0 ? void 0 : device.isDesktop)) {
            if (txnStatusError.isOpen)
                setEditPNLTransactionSuccess(true);
            else
                setEditPNLTransactionFail(true);
        }
    }, [txnStatusError, editPNLTransactionAPICall]);
    useEffect(() => {
        function handleClickCalendarOutside(event) {
            if (calendarRef.current && !calendarRef.current.contains(event.target))
                setOpenCalendar(false);
            if (wrapperRef.current && !wrapperRef.current.contains(event.target))
                setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickCalendarOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickCalendarOutside);
        };
    }, [calendarRef, wrapperRef]);
    useEffect(() => {
        selectOptionUpdateToBeFollowedBy(selectOption);
    }, [selectOption]);
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const closePnlStockDrawer = React.useCallback(() => closeDrawer(), []);
    React.useEffect(() => {
        let t = showFDotCounter();
        setShowFDot(t);
        setFilterDataApplied(t > 0);
    }, [filters]);
    React.useEffect(() => {
        if (sort &&
            sort.filter((s) => {
                if (s.displayName == "Alphabetical" && s.order === -1) {
                    setSortoptionSelected(false);
                    return;
                }
                return s.order !== 0;
            }).length > 0) {
            setSortoptionSelected(true);
        }
    }, [refresh, sort]);
    useEffect(() => {
        if (device === null || device === void 0 ? void 0 : device.isDesktop)
            require("../../../stylesheets/components/Reports/PandLReports/ProfitAndLoss.scss");
        else
            require("../../../stylesheets/components/Reports/PandLReports/ProfitAndLossMob.scss");
        if (searchData)
            setSearchVal(searchData);
    }, []);
    useLayoutEffect(() => {
        setInternalScroll();
    }, [filterSortScrollRef, scroll, filters]);
    useLayoutEffect(() => {
        if (updateSideBarStockMemoised)
            updateSideBarStock(updateSideBarStockMemoised);
    }, [pnLDetails, pnlStockDisplay, updateSideBarStockMemoised]);
    useEffect(() => {
        if (!showShimmer) {
            if (scrollPosition != 0 &&
                scrollPosition === di.pnlReport.viewTransactionClickScrollerPosition) {
                if (device && (device === null || device === void 0 ? void 0 : device.isDesktop))
                    setPnlStockDisplay(true);
                setDefaultTab(di.pnlReport.pnlSideBarTab);
                setPnlStockDetails(selectedStockDetailsFromStore === null || selectedStockDetailsFromStore === void 0 ? void 0 : selectedStockDetailsFromStore.tradeDetails);
                di.pnlReport.viewTransactionClickScrollerPosition = 0;
                di.pnlReport.LThreeWindowbackClick = false;
            }
        }
    }, [showShimmer, scrollPosition]);
    const pnlDetail = useSelector((state) => state.pnlReport.data.PnLData.pnLDetails);
    return (React.createElement("div", null,
        !showShimmer && pnlDetail.length > 0 && PnlDataFlags.isBodEnabled && (React.createElement(PopBodProcessBlock, { bodProcessInfoMessage: PnlDataFlags.bodProcessInfoMessage })),
        props.assetFilter.showList && (React.createElement("div", { className: `${((_b = props.assetFilter.assetProductList) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                "family-tagging-pnl"}` },
            React.createElement("div", { ref: wrapperRef, className: " d-flex align-items-center posrel", style: { width: "auto" } },
                React.createElement("div", { onClick: () => setShowOptions((prevState) => !prevState), className: "selected_option" },
                    selectOption && React.createElement("span", null, selectOption.display),
                    React.createElement("span", { className: "edel-icon-arrow-down" })),
                showOptions && (React.createElement("div", { className: "select_options" }, props.assetFilter.assetProductList.map((x, i) => {
                    if (x.display === selectOption.display)
                        return;
                    return (React.createElement("span", { key: i, onClick: () => closeOptions(x) }, x.display));
                })))),
            props.tabName !== "pnlAll" && !(device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(FamilyTaggingMain, { hideConsolidated: true, oldTheme: true })))),
        React.createElement("div", { className: `calender-section ${(device === null || device === void 0 ? void 0 : device.isMobile) && scrollPosition > 100
                ? "dock_calender_mobile docked_box_shadow_mob"
                : ""} ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "py-1" : ""}` },
            React.createElement("div", { className: "calender-sub-section", ref: calendarRef },
                React.createElement("div", { className: `calendar_date  ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "d-flex" : ""}` },
                    React.createElement("div", null,
                        React.createElement("span", { className: "fin_year" }, financialYears.label),
                        React.createElement("span", null,
                            "\u00A0(",
                            moment(props === null || props === void 0 ? void 0 : props.startDate).format("D-MMM-YY"),
                            "\u00A0 to ",
                            moment(props === null || props === void 0 ? void 0 : props.endDate).format("D-MMM-YY"),
                            ")")),
                    React.createElement("div", null,
                        React.createElement("span", { className: "calendar_change" },
                            (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("i", { className: "edel-icon-calendar2" })) : (React.createElement("i", { className: "edel-icon-calendar-mob" })),
                            React.createElement("span", { onClick: () => {
                                    setOpenCalendar(!openCalendar);
                                    sessionStorage.removeItem("initialLoad");
                                } }, "\u00A0Change")))),
                React.createElement("div", { className: "secondary-navy-theme" }, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(CalendarPopupDesk, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: props.startDate, endDate: props.endDate, finYear: props.finYear, setStartDate: props.setStartDate, setEndDate: props.setEndDate, setFinYear: props.setFinYear, customTime: familyTaggingMemberName !== EConsolidated.CONSOLIDATED, customFields: tillDate(), resetCustomFields: removeSessionOnDateChange, handlePNLDates: props.handlePNLDates })) : (React.createElement(CalendarPopupMob, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: props.startDate, endDate: props.endDate, finYear: props.finYear, setStartDate: props.setStartDate, setEndDate: props.setEndDate, setFinYear: props.setFinYear, customTime: familyTaggingMemberName !== EConsolidated.CONSOLIDATED, customFields: tillDate(), resetCustomFields: removeSessionOnDateChange, handlePNLDates: props.handlePNLDates }))))),
        React.createElement("div", { className: ` ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "summary_details" : ""}` }, showShimmer ? ((device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "summary_box" },
                React.createElement(Skeleton, { height: 100, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "summary_box" },
                React.createElement(Skeleton, { height: 100, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "summary_box" },
                React.createElement(Skeleton, { height: 100, width: "100%", className: "align-top" })),
            React.createElement("div", { className: "summary_box" },
                React.createElement(Skeleton, { height: 100, width: "100%", className: "align-top" })))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { display: "contents" } },
                React.createElement(Skeleton, { height: 87, width: "100%", className: "align-top" }))))) : (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(CommonSummary, { summaryData: commonSummaryValues(), dock: scrollPosition > 150 ? true : false })) : (React.createElement("div", { className: "dashboard-summarydock-mob dashboard-summary_details" },
            React.createElement(CommonSummaryMobile, { summaryData: commonSummaryValues(), TotalsummaryData: [
                    {
                        title: "Day's P&L",
                        value: pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.daysPnLChange,
                        integer: true,
                        externalClassName: "dashboard_dayspnl-mob bgPorcelain",
                        percentageValue: undefined,
                    },
                ], dock: false })))),
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(PnLDownloadSortFilter, { fromDate: props.startDate, toDate: props.endDate, assetType: selectOption.value, searchVal: searchVal, setSearchVal: setSearchVal, showFDot: showFDot, setShowFDot: setShowFDot, sortOptionSelected: sortOptionSelected, setSortoptionSelected: setSortoptionSelected, showSortDropdown: showSortDropdown, setshowSortDropdown: setshowSortDropdown, tabName: pnlSubTab, downloadPopUp: downloadPopUp, setDownloadPopUp: setDownloadPopUp, avoidEmail: downloadPopUp, customSubmit: submitEmailDownload, isSummarize: props.isSummarize, setIsSummarize: props.setIsSummarize, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, duration: props.durationType })) : (React.createElement(PnLDownloadSortFilterMob, { fromDate: props.startDate, toDate: props.endDate, assetType: selectOption.value, searchVal: searchVal, setSearchVal: setSearchVal, showFDot: showFDot, setShowFDot: setShowFDot, sortOptionSelected: sortOptionSelected, setSortoptionSelected: setSortoptionSelected, scrollPosition: scrollPosition, setShowSearchParent: setShowSearchParent, showSortDropdown: showSortDropdown, setshowSortDropdown: setshowSortDropdown, tabName: pnlSubTab, downloadPopUp: downloadPopUp, setDownloadPopUp: setDownloadPopUp, avoidEmail: downloadPopUp, customSubmit: submitEmailDownload, isSummarize: props.isSummarize, setIsSummarize: props.setIsSummarize, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, duration: props.durationType })),
        !showShimmer && (FilterDataApplied || sortOptionSelected) && (React.createElement("div", { className: `filters-tag $scroll overflow-auto ${(device === null || device === void 0 ? void 0 : device.isDesktop)
                ? "dock_filter_desk"
                : (device === null || device === void 0 ? void 0 : device.isMobile) && scrollPosition > 100
                    ? "filters-tag-sticky dock_filter_mob"
                    : ""}
          ${showSearchParent ? "dock_filter_mob_push" : ""}
          `, ref: (e) => (filterSortScrollRef.current = e), onScroll: handleInternalScroll },
            ((_c = sort[0]) === null || _c === void 0 ? void 0 : _c.order) != -1 && sortDisplayName && (React.createElement(SortLabels, { LabelText: sortDisplayName, closeBtn: true })),
            React.createElement(PNLFilterLabelDynamic, { filterData: filters, tabName: props.tabName }),
            (FilterDataApplied || (((_d = sort[0]) === null || _d === void 0 ? void 0 : _d.order) != -1 && sortDisplayName)) && (React.createElement("div", { className: (device === null || device === void 0 ? void 0 : device.isDesktop) ? " " : `clear-all-tag` },
                React.createElement(FilterLabels, { LabelText: " Clear All", closeBtn: false, FilterAction: clearAllLabels }))))),
        !showShimmer && (pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.editableCount) > 0 && (React.createElement("div", { className: "date_band" },
            React.createElement("span", { className: "text" },
                React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "text" }, pnlSummary === null || pnlSummary === void 0 ? void 0 :
                        pnlSummary.editableCount,
                        " instrument",
                        " ",
                        (pnlSummary === null || pnlSummary === void 0 ? void 0 : pnlSummary.editableCount) > 1 && "(s)",
                        " need your attention. You are requested to update correct price details."),
                    "\u00A0",
                    React.createElement("span", { className: "edel-icon-edit" }))))),
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("div", null,
            React.createElement(PnLTable, { pnlStockDisplay: pnlStockDisplay, setPnlStockDetails: setPnlStockDetails, setPnlStockDisplay: setPnlStockDisplay, searchVal: searchVal, simpleFilterData: FilterDataApplied, sortOptionSelected: sortOptionSelected, subtabName: pnlSubTab, setDefaultTab: setDefaultTab, TablefilterSelected: TablefilterSelected, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode }))) : (React.createElement("div", { className: "mb-50p" },
            React.createElement(PnLTableMob, { setPnlStockDetails: setPnlStockDetails, setPnlStockDisplay: setShowPnlStockDrawer, searchVal: searchVal, subtabName: pnlSubTab, TablefilterSelected: TablefilterSelected, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode }))),
        pnlStockDisplay && (React.createElement(PnlStockDetails, { setPnlStockDetails: setPnlStockDetails, setPnlStockDisplay: setPnlStockDisplay, item: pnlStockDetails, fromDate: props.startDate, endDate: props.endDate, assetType: selectOption.value, subtabName: pnlSubTab, setMainLoader: props.setLoader, isDesktop: true, defaultTab: defaultTab, setDefaultTab: setDefaultTab, setDownloadPopUp: setDownloadPopUpSideBar, setDwnldTransactionType: setDwnldTransactionType, editTransaction: editTransaction, isMyaccount: ((_e = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) === null || _e === void 0 ? void 0 : _e.length) > 0
                ? AccountDetails.accountCode === (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)
                : true, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, duration: props.durationType })),
        React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closePnlStockDrawer, isVisible: showPnlStockDrawer, className: "drawer__handle-wrapper-pnl-stock-mobile" },
            React.createElement(PnlStockDetails, { setPnlStockDetails: setPnlStockDetails, setPnlStockDisplay: setShowPnlStockDrawer, item: pnlStockDetails, fromDate: props.startDate, endDate: props.endDate, assetType: selectOption.value, subtabName: pnlSubTab, setMainLoader: props.setLoader, isDesktop: false, setDownloadPopUp: setDownloadPopUpSideBar, setDwnldTransactionType: setDwnldTransactionType, editTransaction: editTransaction, isMyaccount: ((_f = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) === null || _f === void 0 ? void 0 : _f.length) > 0
                    ? AccountDetails.accountCode === (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)
                    : true, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, duration: props.durationType })),
        (showEditablePopup || reviewChangePopup) && (React.createElement(React.Fragment, null,
            !orgTxnLoader && !orgTxnStatus.isOpen && (React.createElement(EditTransactionPopup, { show: showEditablePopup, popTitle: "Edit Transaction", setShow: setShowEditablePopup, popupClass: "", ConfirmBtnTitle: "Confirm", description: "", goBackBtn: false, confirmBtnCta: editConfirmation, goBackCta: () => setShowEditablePopup(false), editableRecord: editableRecord, setPnLEditSplitRequests: setPnLEditSplitRequests, summaryParamters: summaryParamters })),
            React.createElement(ConfirmationPopup, { popupClass: "", description: `You are not allowed to edit the details more than once.
              Are you sure you want to continue?`, popTitle: "Confirm Editing", show: reviewChangePopup, setShow: setReviewChangePopup, btnFirstTitle: "Review Changes", btnSecTitle: "Yes, Confirm", goBackBtn: false, btnFirstCta: reviewGoBack, btnSecCta: reviewConfirm, showFooter: true }))),
        (editTXNShimmer || orgTxnLoader) && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer" },
                React.createElement(PopupLoader, { Title: "Transaction", message: `` })))),
        editPNLTransactionSuccess && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer" },
                React.createElement(SmcasePopupSuccess, { setDownloadSuccess: setEditPNLTransactionSuccess, isDownload: false, Title: "Edit PNL Transaction", operation: null, pageName: "PNL Report", tabName: "", message: "Your request was successfully processed.<br/>" +
                        "Updated price will reflect in the P&L on " +
                        moment(getDay(1)).format("DD-MM-yyyy") +
                        ".", sendBack: true, goBack: () => {
                        document.body.classList.add("flow-overlay");
                        setEditPNLTransactionSuccess(false);
                    } })))),
        (editPNLTransactionFail || orgTxnStatus.isOpen) && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer" },
                React.createElement(SmcasePopupFail, { isDownload: false, setDownloadFail: setEditPNLTransactionFail, Title: "Edit PNL Transaction ", operation: null, pageName: "PNL Report", sendBack: true, goBack: () => {
                        document.body.classList.add("flow-overlay");
                        setEditPNLTransactionFail(false);
                    } })))),
        (downloadPopUpSideBar ||
            showLoaderDownloadSideBar ||
            downloadSuccessDownloadSideBar ||
            downloadFailDownloadSideBar) && (React.createElement(EdModal, { show: downloadPopUpSideBar, setShow: setDownloadPopUpSideBar, size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalDPTitle", title: "Download Profit & Loss Report", showFooter: false },
            React.createElement("div", { className: "downloadHoldingDesk" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12 col-lg-12 downloadHoldingDesk-form" },
                        React.createElement(DownloadReportPopupDesk, { startDate: props.startDate, endDate: props.endDate, withEndDate: true, showLoader: showLoaderDownloadSideBar, setShowLoader: setShowLoaderDownloadSideBar, setDownloadSuccess: setDownloadSuccessDownloadSideBar, setDownloadFail: setDownloadFailDownloadSideBar, resetFields: downloadPopUpSideBar, assetType: selectOption === null || selectOption === void 0 ? void 0 : selectOption.value, submit: (emailFormat, downloadFormat) => {
                                submitEmailDownload(emailFormat, downloadFormat);
                                setDownloadPopUpSideBar(false);
                            }, reportType: DownloadEnumReportType.PNL, avoidEMail: downloadPopUpSideBar })))))),
        (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(React.Fragment, null,
            showLoaderDownloadSideBar && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupLoader, { Title: "Transaction", isDownload: true, message: `Txn Report for ${pnlStockDetails.scripName} report is getting prepared to download` })))),
            downloadSuccessDownloadSideBar && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccessDownloadSideBar, Title: "Transaction", operation: "download", pageName: "Profit & Loss", message: `Your ${pnlStockDetails.scripName} Txn report is successfully downloaded`, sendBack: true, goBack: () => {
                            goBackToPNLReport();
                            setPnlStockDetails(null);
                        }, isDownload: true })))),
            downloadFailDownloadSideBar && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupFail, { setDownloadFail: setDownloadFailDownloadSideBar, Title: "Transaction", operation: "download", pageName: "Profit & Loss", sendBack: true, goBack: () => {
                            goBackToPNLReport();
                            setPnlStockDetails(null);
                        }, isDownload: true }))))))));
};
export default ProfitAndLossComponent;
